import {
  FETCH_INVENTORYSUMMERY_REQUEST,
  FETCH_INVENTORYSUMMERY_SUCCESS,
  FETCH_INVENTORYSUMMERY_FAILURE,
} from "./inventorysummeryTypes";
import api from "../../utils/Api";

export const fetchInventorySummaryRequest = () => {
  return {
    type: FETCH_INVENTORYSUMMERY_REQUEST,
  };
};

export const fetchInventorySummarySuccess = (inventorysummaryData) => {
  return {
    type: FETCH_INVENTORYSUMMERY_SUCCESS,
    payload: inventorysummaryData,
  };
};

export const fetchInventorySummaryFailure = (error) => {
  return {
    type: FETCH_INVENTORYSUMMERY_FAILURE,
    payload: error,
  };
};

export const fetchInventorySummary = () => {
  const headers = {
    Authorization:
      "Bearer " + JSON.parse(localStorage.getItem("USER_INFO")).token,
  };
  return async (dispatch) => {
    dispatch(fetchInventorySummaryRequest());
    try {
      const response = await api.get("inventory/details/fetch", {
        headers: headers,
      });
      const inventorysummaryData = response.data.data;
      dispatch(fetchInventorySummarySuccess(inventorysummaryData));
    } catch (error) {
      console.log("Redux error - ", error.response);
      const errorMsg = error.message;
      dispatch(fetchInventorySummaryFailure(errorMsg));
    }
  };
};
